<script setup>
defineProps({
  example: { type: Object, required: true },
  startOpen: { type: Boolean, default: false },
})
</script>

<template>
  <section class="example-box worked-example" :class="{ 'teaching-example': example.mode === 'explain' }">
    <div class="example-title"><span>{{ example.title }}</span><small v-if="example.mode === 'explain'">CÙNG HỌC CÁCH GIẢI</small></div>
    <div class="example-body">
      <p class="example-problem"><strong>Đề bài</strong>{{ example.problem }}</p>
      <details :open="startOpen || example.mode === 'explain'">
        <summary>{{ example.mode === 'explain' ? 'Lời giảng từng bước' : 'Xem lời giải từng bước' }}</summary>
        <div class="solution-steps"><p v-for="(step, index) in example.solution.split('\n')" :key="index">{{ step }}</p></div>
        <p v-if="example.takeaway" class="example-takeaway"><strong>Điều em rút ra</strong>{{ example.takeaway }}</p>
      </details>
    </div>
  </section>
</template>
